import { createFileRoute, Link } from "@tanstack/react-router";
import { motion } from "framer-motion";

export const Route = createFileRoute("/obrigado")({
  head: () => ({
    meta: [
      { title: "Diagnóstico enviado com sucesso | Obrigado" },
      {
        name: "description",
        content:
          "Recebemos suas respostas. Em breve enviaremos o diagnóstico tributário detalhado para seu contato.",
      },
      { property: "og:title", content: "Diagnóstico enviado com sucesso" },
      {
        property: "og:description",
        content: "Recebemos suas respostas do diagnóstico tributário.",
      },
    ],
  }),
  component: Obrigado,
});

function Obrigado() {
  return (
    <main className="flex min-h-screen items-center justify-center px-4 py-16">
      <motion.section
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        className="glass-panel relative overflow-hidden w-full max-w-lg rounded-3xl p-8 text-center sm:p-12"
      >
        <div className="absolute inset-x-0 top-0 h-0.5 rounded-t-3xl gradient-primary" />
        {/* ícone centralizado */}
        <div className="relative mx-auto mb-8 flex size-24 items-center justify-center">
          <motion.span
            className="absolute inset-0 rounded-full bg-primary/25 blur-2xl"
            animate={{ opacity: [0.4, 0.9, 0.4], scale: [0.9, 1.1, 0.9] }}
            transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
          />
          <motion.div
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: "spring", stiffness: 240, damping: 16, delay: 0.15 }}
            className="relative flex size-20 items-center justify-center rounded-full border border-primary/40 gradient-primary glow-primary"
          >
            <motion.span
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ type: "spring", stiffness: 300, damping: 14, delay: 0.45 }}
              className="flex items-center justify-center"
            >
              <i className="fi fi-tr-badge-check flex items-center justify-center text-4xl leading-none text-primary-foreground" />
            </motion.span>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
        >
          <h1 className="text-2xl font-bold leading-snug sm:text-3xl">Muito obrigado!</h1>
          <p className="mt-2 text-sm font-medium text-primary">
            Seu diagnóstico foi enviado com sucesso.
          </p>
          <p className="mx-auto mt-4 max-w-sm text-sm leading-relaxed text-muted-foreground">
            Nossa equipe recebeu seus dados e em breve enviaremos o diagnóstico tributário detalhado
            para o seu contato.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.55, ease: "easeOut" }}
          className="mt-9"
        >
          <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.97 }}>
            <Link
              to="/"
              className="inline-flex items-center gap-2.5 rounded-2xl border border-primary/35 bg-primary/8 px-8 py-3.5 text-sm font-semibold text-primary backdrop-blur-md transition-all duration-200 hover:border-primary/65 hover:bg-primary/15 hover:shadow-[0_0_24px_-6px_oklch(0.688_0.212_41.5/0.5)]"
            >
              <i className="fi fi-tr-refresh leading-none" />
              Iniciar novo diagnóstico
            </Link>
          </motion.div>
        </motion.div>
      </motion.section>
    </main>
  );
}
